export default {
    media: {
        select: {
            video: "Select a video (MP4, MOV, WebM)",
            audio: "Select an audio file (MP3, M4A, AAC, WAV, OGG)",
        },
        noFile: {
            video: "No video",
            audio: "No audio",
        },
        remove: "Remove",
        validation: {
            badFormat: {
                video: "The video must be in MP4, MOV or WebM format.",
                audio: "The audio must be in MP3, M4A, AAC, WAV or OGG format.",
            },
            maxFileSize: {
                video: "The video must not exceed 500 MB.",
                audio: "The audio must not exceed 100 MB.",
            },
        },
    },
    image: {
        title: "Images",
        name: "Image",
        upload: "Upload",
        uploadSuccess: "Images uploaded successfully",
        uploadError: "Error during upload",
        drop: "Click or drag and drop an image",
        dropOrClick: "Click or drag and drop a new image",
        myImages: "Training images",
        sharedImage: "Shared images",
        noImage: "No image has been uploaded",
        noImageSelected: "No image selected",
        pickerImage: "Images",
        pickerUpload: "Upload",
        selectImage: "Select an image",
        replaceImage: "Replace image",
        currentImage: "Current image",
        newImage: "New image",
        remove: "Remove",
        validation: {
            badFormat: "File must be in JPG, PNG or SVG format.",
            maxFileSize: "Image must not exceed 5MB.",
            badImageSize:
                "Image must have dimensions of 500x500px or 625x500px.",
            imageNotReadable: "Unable to read image.",
            tooSmallImage: "Image is too small.",
            conversionError: "Error during image conversion.",
            loadError: "Error loading image.",
        },
    },
    topicCategory: {
        title: "Categories",
        field: {
            name: "Name",
            rank: "Rank",
        },
    },
    trainingVersion: {
        title: "Training versions",
        field: {
            rank: "#",
            title: "Title",
            description: "Description",
            isAvailable: "Available",
            topicIds: "Topics",
            topicIdsPlaceholder: "Search and select topics included in this version.",
            relatedTopicIds: "Related topics",
            relatedTopicIdsPlaceholder:
                "Search and select related topics.",
        },
    },
    testimony: {
        title: "Testimonials",
        status: {
            draft: "Draft",
            available: "Available",
            unavailable: "Unavailable",
        },
        field: {
            title: "Title",
            subtitle: "Subtitle",
            description: "Description",
            status: "Status",
            image: "Image",
            videoLink: "Video Link",
            text: "Text",
            tags: "Tags",
            keywords: "Search keywords",
            comments: "Comments",
            rank: "Rank",
        },
    },
    topic: {
        title: "Topics",
        new: "New topic",
        status: {
            draft: "Draft",
            available: "Available",
            unavailable: "Unavailable",
        },
        level: {
            all: "All",
            beginner: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
        },
        help: "The information is displayed in the application as follows:",
        field: {
            title: "Title",
            description: "Description",
            image: "Image",
            level: "Level",
            status: "Status",
            tags: "Tags",
            rank: "Rank",
            category: "Category",
            keywords: "Search keywords",
            introduction: "Introduction",
            synthesis: "Synthesis",
            conclusion: "Conclusion",
            goals: "Goals",
            relatedTopics: "Related topics",
            relatedTopicsPlaceholder:
                "Search and tick the topics to link to this one.",
            comments: "Comments",
            categoryPlaceholder: "Select a category",
            titlePlaceholder: "The Foundations of Marriage",
            descriptionPlaceholder:
                "Understanding the basics of a solid marriage",
            levelPlaceholder: "All",
            statusPlaceholder: "Available",
            tagsPlaceholder: "Marriage, Family, Relationship",
            keywordsPlaceholder: "marriage, family, relationship",
            introductionPlaceholder: "Introduction",
            synthesisPlaceholder: "Synthesis",
            conclusionPlaceholder: "Conclusion",
            goalsPlaceholder: "Goals",
            commentsPlaceholder: "",
        },
    },
    topicPart: {
        title: "Parts",
        new: "New part",
        addSynthesisPart: "Synthesis part",
        synthesisPartAlreadyExists:
            "Only one synthesis part is allowed per topic",
        defaultSynthesis: {
            title: "Couple evening",
            description:
                "We take time together to exchange and review the topic together",
            text: "I can now take a few moments to reread my answers, select the ones I wish to share, then answer the synthesis questions",
            question1: "What do I want to share?",
            question2: "What is the most important point of this topic for me?",
        },
        field: {
            answerTogether: "Answers together",
            isSynthesisPart: "Synthesis part",
            title: "Title",
            description: "Description",
            image: "Image",
            duration: "Duration (min)",
            videoLink: "Video Link",
            videoFile: "Video file",
            audioFile: "Audio file",
            contentText: "Text",
            additionalText: "Additional Text (See more)",
            comments: "Comments",
            rank: "Rank",
            titlePlaceholder: "The Basics of Christian Marriage",
            descriptionPlaceholder: "Presentation of fundamental pillars",
            durationPlaceholder: "30",
            videoLinkPlaceholder: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            contentTextPlaceholder: "Enter main text",
            additionalTextPlaceholder: "Enter additional text",
            commentsPlaceholder: "",
        },
        validation: {
            videoSourceConflict:
                "Choose either a video link or a video file, not both.",
        },
    },
    topicPartQuestion: {
        title: "Questions",
        answerType: {
            text: "Text",
            multipleChoice: "Multiple choice",
            singleChoice: "Single choice",
            yesNo: "Yes - No",
            yesNoUnknown: "Yes - No - Don't know",
        },
        field: {
            text: "Question",
            textPlaceholder: "What are the pillars of a Christian marriage?",
            answerType: "Answer type",
            type: "Type",
            answers: "Answers",
            rank: "Rank",
            comments: "Comments",
        },
    },
};
